import { configureStore, combineReducers, ThunkAction, Action } from '@reduxjs/toolkit';
import businessReducer from '../reducers/businessSlice';
import customersReducer from '../reducers/customersSlice';
import addressesReducer from '../reducers/addressesSlice';
import employeesReducer from '../reducers/employeesSlice';
import contactsReducer from '../reducers/contactsSlice';
import receptionistReducer from '../reducers/receptionistSlice';
import globalReducer from '../reducers/globalSlice';
import chatReducer from '../reducers/chatSlice';
import commsReducer from '../reducers/communicationsSlice';
import bookingsReducer from '../reducers/bookingsSlice';
import numbersReducer from '../reducers/numbersSlice';
import buyNumberReducer from '../reducers/buyNumberSlice';
import callsReducer from '../reducers/callSlice';
import aiConfigReducer from '../reducers/aiConfigSlice';
import { apiSlice } from '../api/apiSlice';
import storage from 'redux-persist/lib/storage';
import { createTransform, persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

const stripTransientGlobalState = createTransform(
  (inboundState: any, key) => {
    if (key !== 'global' || !inboundState) {
      return inboundState;
    }

    return {
      ...inboundState,
      confirmModalProps: undefined,
    };
  },
  (outboundState: any, key) => {
    if (key !== 'global' || !outboundState) {
      return outboundState;
    }

    return {
      ...outboundState,
      confirmModalProps: undefined,
    };
  }
);

const persistConfig = {
  key: 'project-secretary-root-v2',
  storage,
  transforms: [stripTransientGlobalState],
}

const rootReducer = combineReducers({
  business: businessReducer,
  customers: customersReducer,
  addresses: addressesReducer,
  employees: employeesReducer,
  contacts: contactsReducer,
  receptionist: receptionistReducer,
  global: globalReducer,
  chat: chatReducer,
  communications: commsReducer,
  bookings: bookingsReducer,
  numbers: numbersReducer,
  buyNumber: buyNumberReducer,
  calls: callsReducer,
  aiConfig: aiConfigReducer,
  [apiSlice.reducerPath]: apiSlice.reducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({serializableCheck: false}).concat(apiSlice.middleware, thunk)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export const persistor = persistStore(store);
